import type { AttributionModel } from '@/api/types'
import { tmtAttributedLabel } from '@/components/TmtAttributedBadge'
import { Card, HorizontalBarChart } from '@/design'
import { formatMoney } from '@/features/analytics/advertising/metrics'
import { CardQueryBody } from '@/features/overview/CardQueryBody'

import { campaignName } from './campaignName'
import { advertisingSectionError } from './errors'
import type { OverviewQueryLike } from './overviewQuery'
import { NotAvailable } from './SectionStates'

/** The API's best campaigns by TmT ROAS, in its order (ties to more spend; no ROAS last). */
export function TopCampaignsCard({ query, model }: { query: OverviewQueryLike; model: AttributionModel }) {
  return (
    <Card title="Top campaigns by ROAS" subtitle={`${tmtAttributedLabel(model)} ROAS · best first`}>
      <CardQueryBody query={query} loadingRows={5} errorDescription={advertisingSectionError(query.error, 'The top campaigns could not be loaded.')}>
        {(overview) => {
          if (overview.notAvailable.roas) return <NotAvailable />
          const currency = overview.meta.currency
          return (
            <HorizontalBarChart
              title={`ROAS (${tmtAttributedLabel(overview.meta.model)}), top ${overview.topCampaigns.length} campaigns`}
              rows={overview.topCampaigns.map((row) => ({
                key: row.id,
                label: campaignName(row),
                value: row.tmt.roas,
                nullLabel: 'No spend',
                detail: `${formatMoney(row.spendMinor, currency)} spend`,
              }))}
              format="ratio"
              emptyMessage="No campaign had spend in this period."
            />
          )
        }}
      </CardQueryBody>
    </Card>
  )
}
